import React, { Suspense, lazy } from 'react';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Route, Switch } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import * as firebase from 'firebase/app';
import PrivateRoute from 'components/PrivateRoute';

// https://reactjs.org/docs/code-splitting.html
const Home = lazy(() => import('./HomePage'));
const Signin = lazy(() => import('./SigninPage'));
const Signup = lazy(() => import('./SignupPage'));
const DashBoardPage = lazy(() => import('./DashBoardPage'));
const BuilderPage = lazy(() => import('./BuilderPage'));
const BackTestPage = lazy(() => import('./back-test/[authorId]/[algorithmId]'));

// https://github.com/tylermcginnis/react-router-firebase-auth
function AppRouter() {
  const [, initialising] = useAuthState(firebase.auth());

  const loading = (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      css={{
        height: '100vh'
      }}
    >
      <CircularProgress size={64} />
    </Box>
  );
  return (
    <Suspense fallback={loading}>
      {initialising ? (
        loading
      ) : (
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/signin" exact component={Signin} />
          <Route path="/signup" exact component={Signup} />

          <PrivateRoute path="/dashboard" component={DashBoardPage} />
          <PrivateRoute path="/builder/:authorId/:id" component={BuilderPage} />
          <PrivateRoute
            path="/back-test/:authorId/:algorithmId"
            component={BackTestPage}
          />
        </Switch>
      )}
    </Suspense>
  );
}

export default AppRouter;
